import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: 'What is a medical certificate generator?',
      answer: 'A medical certificate generator is an online tool that helps you create professional medical certificate templates quickly with customizable patient, doctor, and clinic details. It is designed for use by clinics, doctors, students (draft purposes), and HR documentation.'
    },
    {
      question: 'Is this medical certificate generator free?',
      answer: 'Yes! Our medical certificate generator is 100% free to use. Create unlimited certificates without any registration, subscription, or hidden fees.'
    },
    {
      question: 'Is this a legally valid medical certificate?',
      answer: 'No. This tool generates templates only. A legally valid medical certificate must be issued by a licensed medical practitioner with their signature and official stamp/seal. This tool is for drafting, study, and HR template purposes only.'
    },
    {
      question: 'Can I download the certificate as a PDF?',
      answer: 'Yes. Click the "Download PDF" button after filling in your details. The certificate will be downloaded as a high-quality PDF file ready for printing.'
    },
    {
      question: 'Is my information secure when using this tool?',
      answer: 'Your privacy is our priority. All certificate generation happens entirely in your browser — we never store, transmit, or have access to any personal or medical information you enter.'
    },
    {
      question: 'What types of certificates can I generate?',
      answer: 'You can generate four types: (1) Prescription - for medical prescriptions, (2) Sick Leave Certificate — for leave application due to illness, (3) Fitness Certificate — to certify a person is medically fit, and (4) General Medical Certificate — a versatile format for general medical documentation.'
    },
    {
      question: 'How to generate a medical certificate?',
      answer: 'To generate a medical certificate: (1) Use our free generator tool above — select the certificate type, fill in patient and doctor details, enter the diagnosis, and click Generate. (2) Download the professional PDF template. (3) Take the template to a registered doctor who will review it, add their clinical findings, sign it, and apply their official stamp to make it legally valid.'
    },
    {
      question: 'Can I use AI to generate a medical certificate?',
      answer: 'AI tools can create professional templates and assist with formatting. However, a document only becomes a legally valid certificate after a licensed doctor reviews, signs, and stamps it following an actual examination. AI alone cannot produce a legally valid certificate.'
    },
    {
      question: 'What are the benefits of a medical certificate?',
      answer: 'Medical certificates provide multiple benefits: they legally justify absence from work or school, protect employees from disciplinary action, enable insurance claim processing, satisfy government and visa medical requirements, document chronic conditions for long-term HR records, and provide medico-legal evidence in disputes.'
    },
    {
      question: 'How long does it take to make a medical certificate?',
      answer: 'Using our free generator, a certificate template is ready in under 2 minutes. Simply fill in the form, preview your certificate, and download it instantly as a PDF or image.'
    },
    {
      question: 'Who can issue a valid medical certificate?',
      answer: 'Only a registered medical practitioner (MBBS and above) listed on the National Medical Commission (NMC) or state medical council register is eligible to issue a valid medical certificate in India. This includes MBBS doctors, MD/MS specialists, and registered AYUSH practitioners for some contexts.'
    },
    {
      question: 'Can a medical certificate be challenged?',
      answer: 'Yes. Employers and institutions can challenge a medical certificate by verifying the doctor\'s registration number on the NMC/state council website, calling the listed clinic directly, or requesting an independent medical examination.'
    }
  ];

  return (
    <div className="py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-pink-600 font-semibold mb-2">Got Questions?</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem key={faq.question} value={`item-${index}`} className="bg-white rounded-lg px-6 border">
              <AccordionTrigger className="text-left font-semibold text-gray-800 hover:text-pink-600">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQSection;